import { BarChart2 } from 'lucide-react';
import { CampaignFormSectionCard } from '@/components/campaigns/campaign-form-section-card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useI18nContext } from '@/i18n/i18n-react';

export interface CampaignTrackingSectionProps {
  utmCampaign: string;
  utmCampaignError?: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  className?: string;
}

export function CampaignTrackingSection({
  utmCampaign,
  utmCampaignError,
  onChange,
  onBlur,
  className,
}: CampaignTrackingSectionProps) {
  const { LL } = useI18nContext();

  return (
    <CampaignFormSectionCard
      icon={BarChart2}
      title={LL.createCampaign.sections.tracking.title()}
      description={LL.createCampaign.sections.tracking.description()}
      className={className}
    >
      <div className="space-y-2">
        <Label htmlFor="utmCampaign">
          {LL.createCampaign.utmCampaignLabel()}
        </Label>
        <Input
          id="utmCampaign"
          name="utmCampaign"
          value={utmCampaign}
          onChange={onChange}
          onBlur={onBlur}
          required
          className={utmCampaignError ? 'border-red-500' : ''}
        />
        {utmCampaignError ? (
          <p className="mt-1 text-sm text-red-500">{utmCampaignError}</p>
        ) : null}
        <p className="mt-1 text-sm text-muted-foreground">
          {LL.createCampaign.utmCampaignDescription()}
        </p>
      </div>
    </CampaignFormSectionCard>
  );
}
